import { useBreakpointValue } from '@genial/utils';
import React from 'react';

import { PrivatePensionEntityNormalized } from '../../../../../../../../../store/product/types';
import { PrivatePensionAssetProvider } from '../../../../../../../../BatchTicket/components/DynamicAsset/contexts/products/PrivatePension';
import { ItemDetails } from '../Details';

import { PrivatePensionItemDesktop } from './desktop';
import { PrivatePensionItemMobile } from './mobile';
import { PrivatePensionItemTablet } from './tablet';

export namespace PrivatePensionItemTypes {
  export interface Props {
    offer: PrivatePensionEntityNormalized;
  }
}

export const PrivatePensionItem: React.FC<PrivatePensionItemTypes.Props> = ({ offer }) => {
  const privatePensionItem = useBreakpointValue({
    base: <PrivatePensionItemMobile offer={offer} />,
    sm: <PrivatePensionItemTablet offer={offer} />,
    lg: <PrivatePensionItemDesktop offer={offer} />,
  });

  return (
    <PrivatePensionAssetProvider>
      <ItemDetails />
      {privatePensionItem}
    </PrivatePensionAssetProvider>
  );
};
